import React, { PropsWithChildren } from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import bem from '../../../lib/bemUtils/bem';

export enum TileGridModifier {
  TWO_COLUMNS_MAX = 'tiles__grid--two-columns-max',
}

type TileGridProps = {
  modifier?: Modifier<TileGridModifier>;
} & PropsWithChildren;

export function TileGrid({ children, modifier }: TileGridProps) {
  return <ol className={bem('tiles__grid', modifier)}>{children}</ol>;
}
